import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getArchiveSession } from '../../archive/session';

export default function ArchiveProtectedRoute({
  children,
  admin = false,
}: {
  children: ReactNode;
  admin?: boolean;
}) {
  const location = useLocation();
  const session = getArchiveSession();
  if (!session) {
    return <Navigate to="/archive/login" replace state={{ from: location.pathname }} />;
  }
  if (admin && session.role !== 'admin' && session.role !== 'super_admin') {
    return <Navigate to="/archive" replace />;
  }
  return children;
}
